import { Observable } from 'rxjs';
import { OtpModel, OtpRequest } from '@src/core/domain/otp/otp.model';

export abstract class OtpRepository {
  abstract postOtp(params: OtpRequest): Observable< OtpModel >;
}
